module.exports = __webpack_public_path__ + "img/baike.a5bf3edd.png";